import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";

import { IStatusIndicatorControl } from "./status-indicator-model";

export const StatusIndicatorStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "status-indicator",
})<IStatusIndicatorControl>`
  padding: 3px 5px;
  border-radius: 3px;
  border-inline-start: 2px solid ${props => props.$borderColor};
  background-color: ${props => props.$bgColor};
  color: ${props => props.$color};
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
`;
